import { Tooltip } from '@ds';
import { MdOutlineInfo } from 'react-icons/md';
import { useLogisticsPermissions } from '@lp/features/RoutePlanner/hooks/useLogisticsPermissions';
import { Case } from '@/api/apis/case';
import { useCaseDetails } from '@/hooks/useCaseDetails';
import { LogisticsButtons } from './LogisticsButtons';

type RouteLogisticsButtonsProps = {
  isValidRoute: boolean;
  isValidLocations: boolean;
  errorMessage: string;
};

export const RouteLogisticsButtons = ({ isValidLocations, isValidRoute, errorMessage }: RouteLogisticsButtonsProps) => {
  const { status } = useCaseDetails() as Case;
  const { isReviewQuote } = useLogisticsPermissions();

  return (isValidRoute && isValidLocations) || isReviewQuote ? (
    <LogisticsButtons caseStatus={status} isValidRoute={isValidRoute && isValidLocations} />
  ) : (
    <Tooltip isDisabled={!errorMessage} content={errorMessage}>
      <div className="text-black">
        <MdOutlineInfo size={20} />
      </div>
    </Tooltip>
  );
};
